/**
 * Copyright IBM Corp. 2022, 2026
 */

import s from './style.module.css'

export default function SlidesBlock({ slideshareEmbedKey }) {
	return (
		<section className={s.slides}>
			<iframe
				title={slideshareEmbedKey}
				src={`//www.slideshare.net/slideshow/embed_code/key/${slideshareEmbedKey}`}
				width="595"
				height="485"
				frameBorder="0"
				scrolling="no"
				className={s.iframe}
				allowFullScreen
			/>
		</section>
	)
}
